import { createFileRoute } from "@tanstack/react-router";
import { AbroadGuestInvite } from "@/components/abroad/AbroadGuestInvite";
import { guestInviteHead } from "@/components/abroad/abroad-guest-head";
import { getEduGuestInvite } from "@/lib/edu-guest-invite.functions";
import type { InviteView } from "@/edu/guest-invite";
import { getEduCountriesCount, type CountriesHead } from "@/lib/edu-countries-count.functions";

// Именное приглашение на подбор вузов (en). Без индексации: личная ссылка.
// Loader читает приглашение на сервере — именное превью для мессенджеров
// (og:title с именем, картинка по токену). Открытие отмечает браузер.
export const Route = createFileRoute("/en/study-abroad_/invite/$token")({
  loader: async ({ params }): Promise<{ initial: InviteView | null; countries: CountriesHead | null }> => {
    const [initial, countries] = await Promise.all([
      getEduGuestInvite({ data: { token: params.token } }).catch(() => null),
      getEduCountriesCount().catch(() => null),
    ]);
    return { initial, countries };
  },
  head: ({ params, loaderData }) => guestInviteHead("en", params.token, loaderData?.initial, loaderData?.countries),
  component: function GuestInviteRoute() {
    const { token } = Route.useParams();
    const { initial } = Route.useLoaderData();
    return <AbroadGuestInvite lang="en" token={token} initial={initial} />;
  },
});
